import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Grid, Typography, TextField, IconButton, Avatar, Box, Button, Dialog, AppBar, Toolbar,
  TableContainer, Paper, Table, TableHead, TableRow, TableCell, tableCellClasses, styled, TableBody,
  TablePagination, Container
} from '@mui/material';
import { Close, Send } from '@mui/icons-material';
import { RotatingLines } from 'react-loader-spinner';
import Swal from 'sweetalert2';
import { Buffer } from 'buffer';

import { API } from 'aws-amplify';

import ErrorView from '../error';
import { open, close } from '../../features/loading/loadingSlice';
import { update } from '../../features/admin/adminSlice';

const AvatarBox = (props) => {
  return (
    <Box spacing={1} sx={{ display: 'flex', flexWrap: 'wrap', }}>
      {
        props.numbers.map((number, index) => {
          return index % 2 === 0 ? <Avatar key={index} sx={{ bgcolor: '#33ab9f', m: 1, }}>{number}</Avatar> :
            <Avatar key={index} sx={{ bgcolor: '#ffcf33', color: '#000', m: 1 }} >{number}</Avatar>
        })
      }
    </Box>
  )
}

const EntryInfoDialog = (props) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.secondary.light, color: theme.palette.common.black, fontSize: 14,
      fontWeight: 'bold', border: '0.5px solid', padding: '3px 8px', overFlowWrap: 'anywhere'
    },
    [`&.${tableCellClasses.body}`]: { fontSize: 12, border: '0.5px solid', padding: '3px 8px', overflowWrap: 'anywhere' },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover, },
  }));

  return (
    <Dialog fullScreen open={props.open}>
      <AppBar sx={{ position: 'absolute' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>エントリー情報</Typography>
          <IconButton color='inherit' onClick={props.handleClose} aria-label='close'><Close /></IconButton>
        </Toolbar>
      </AppBar>
      <Container fixed sx={{ paddingTop: '80px', paddingBottom: '10px', height: '100vh' }}>
        <TableContainer component={Paper} sx={{ height: 'calc(100% - 50px)' }}>
          <Table sx={{ minWidth: '960px' }} aria-label='エントリー情報' stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell width={40}>項番</StyledTableCell>
                <StyledTableCell width={100}>氏名</StyledTableCell>
                <StyledTableCell width={180}>地区名</StyledTableCell>
                <StyledTableCell width={180}>事業所名</StyledTableCell>
                <StyledTableCell width={100}>社員番号</StyledTableCell>
                <StyledTableCell width={160}>メールアドレス</StyledTableCell>
                <StyledTableCell width={200}>ビンゴカード</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.rows.map((row) => (
                <StyledTableRow key={row.entry_id}>
                  <StyledTableCell component='th' scope='row'>{row.entry_id}</StyledTableCell>
                  <StyledTableCell>{row.user_name}</StyledTableCell>
                  <StyledTableCell>{row.union_name}</StyledTableCell>
                  <StyledTableCell>{row.office}</StyledTableCell>
                  <StyledTableCell>{row.phone}</StyledTableCell>
                  <StyledTableCell>{row.email}</StyledTableCell>
                  <StyledTableCell>
                    {row.bingo_mass_00}, {row.bingo_mass_01}, {row.bingo_mass_02}, {row.bingo_mass_03}, {row.bingo_mass_04}
                    , {row.bingo_mass_10}, {row.bingo_mass_11}, {row.bingo_mass_12}, {row.bingo_mass_13}, {row.bingo_mass_14}
                    , {row.bingo_mass_20}, {row.bingo_mass_21}, {row.bingo_mass_22}, {row.bingo_mass_23}, {row.bingo_mass_24}
                    , {row.bingo_mass_30}, {row.bingo_mass_31}, {row.bingo_mass_32}, {row.bingo_mass_33}, {row.bingo_mass_34}
                    , {row.bingo_mass_40}, {row.bingo_mass_41}, {row.bingo_mass_42}, {row.bingo_mass_43}, {row.bingo_mass_44}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination component='div' labelDisplayedRows={({ from, to, count }) => { return `${from} – ${to} / ${count}`; }}
          labelRowsPerPage='１ページあたりの表示数' count={props.count} rowsPerPage={props.rowsPerPage} page={props.page}
          onPageChange={props.onPageChange} onRowsPerPageChange={props.onRowsPerPageChange} />
      </Container>
    </Dialog>
  )
}

const Content = (props) => {
  const [number, setNumber] = useState('');
  const [numberHelperText, setNumberHelperText] = useState('');
  const [numberError, setNumberError] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [entryInfos, setEntryInfos] = useState([]);
  const [count, setCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  useEffect(() => { getData(); }, []);

  const changeNumber = (event) => {
    let newNumber = event.target.value;
    setNumber(newNumber);
    if (!(/^([1-9]\d*|0|)$/.test(newNumber)) || parseInt(newNumber) > 99 || parseInt(newNumber) === 0) {
      setNumberHelperText('1から99までの数字のみ入力可能');
      setNumberError(true);
    } else if (props.winNums.includes(Number(newNumber))) {
      setNumberHelperText('当選番号以外の数字を入力してください');
      setNumberError(true);
    } else {
      setNumberHelperText('');
      setNumberError(false);
    }
  }

  const getData = () => {
    let data = { body: { operation: 'getAdminData' } };
    props.open();
    API.post('uabingoapi', '/entry', data)
      .then(response => {
        props.close();
        props.update(response);
      })
      .catch(error => {
        props.close();
        ErrorView(error.response.data.message);
      });
  }

  const send = () => {
    if (!numberError) {
      let data = { body: { operation: 'addNum', number: number } };
      props.open();
      API.post('uabingoapi', '/entry', data)
        .then(response => {
          setNumber('')
          let records = response['records']
          if (records !== undefined) {
            let username_html = ''
            for (let i = 0; i < records.length; i++) {
              username_html += ('<p>' + records[i].user_name + ' ・ ' + records[i].union_name + '</p>')
            }
            Swal.fire({
              title: '当選者が出ました',
              html: username_html,
              confirmButtonColor: '#33ab9f',
            })
          }
          props.close();
          getData();
        })
        .catch(error => {
          props.close();
          ErrorView(error.response.data.message);
        });
    }
  }

  const outputExcel = (base64Response, filename) => {
    const byteArray = Buffer.from(base64Response, 'base64');
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    if (typeof window.navigator.msSaveBlob != 'undefined') {
      window.navigator.msSaveBlob(blob, filename)
    } else {
      let objectUrl = URL.createObjectURL(blob);
      let link = document.createElement('a')
      link.href = objectUrl
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  const outputWinner = () => {
    let data = { body: { operation: 'outputWinner' } };
    props.open();
    API.post('uabingoapi', '/entry', data)
      .then(response => {
        outputExcel(response.excel, '当選者リスト.xlsx');
        props.close();
      })
      .catch(error => {
        console.log(error)
        props.close();
        ErrorView(error.response.data.message);
      });
  }

  const getEntryInfos = (page, rowsPerPage) => {
    let startIdx = page * rowsPerPage;
    let endIdx = (page + 1) * rowsPerPage;
    if (entryInfos && entryInfos.length >= endIdx) {
      setRows(entryInfos.slice(startIdx, endIdx))
      setPage(page)
      setDialogOpen(true)
    } else {
      let data = {
        body: {
          operation: 'getEntryInfos',
          startEntryId: entryInfos.length > 0 ? entryInfos[entryInfos.length - 1].entry_id : 0,
          rowCount: endIdx - entryInfos.length
        }
      };
      props.open();
      API.post('uabingoapi', '/entry', data)
        .then(response => {
          setCount(response.count)
          setEntryInfos([...entryInfos, ...response.data])
          setRows([...entryInfos.slice(startIdx), ...response.data])
          setPage(page)
          props.close();
          setDialogOpen(true)
        })
        .catch(error => {
          console.log(error)
          props.close();
          ErrorView(error.response.data.message);
        });
    }
  }

  const onPageChange = (event, newPage) => {
    getEntryInfos(newPage, rowsPerPage);
  }

  const onRowsPerPageChange = (event) => {
    getEntryInfos(0, parseInt(event.target.value, 10));
    setRowsPerPage(parseInt(event.target.value, 10));
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} m={2}>
          <Typography variant='h6' align='center'>
            イオン銀行従業員組合
          </Typography>
          <Typography variant='h5' align='center'>
            10周年記念全国ご当地オンラインビンゴ大会管理画面
          </Typography>
        </Grid>
        <Grid item md={6} xs={12} paddingLeft={2} paddingRight={2}>
          <TextField margin='normal' label='当選番号' value={number} onChange={(event) => { changeNumber(event) }}
            InputProps={{ endAdornment: <IconButton onClick={send}><Send /></IconButton> }} helperText={numberHelperText}
            error={numberError} />
        </Grid>
        <Grid item md={6} xs={12} paddingLeft={{ xs: 2, md: 0 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          <Button variant='outlined' color='primary' onClick={() => { getEntryInfos(page, rowsPerPage) }}>エントリー情報を確認</Button>
        </Grid>
        <Grid item xs={12} m={2}>
          <fieldset>
            <legend>当選した番号</legend>
            <AvatarBox numbers={props.winNums} />
          </fieldset>
        </Grid>
        <Grid item xs={3} m={2}><Typography variant='h6'>当選者数</Typography></Grid>
        <Grid item xs={9} m={2}>
          {false ? <RotatingLines trokeColor='teal' strokeWidth='5' animationDuration='0.75' width='96' visible={true} /> :
            <>
              <Typography variant='h4' color='#33ab9f'>
                {props.winnerCount}
                <Button variant='outlined' color='primary' sx={{ marginLeft: '50px' }} onClick={outputWinner}>当選者を出力</Button>
              </Typography>
            </>}
        </Grid>
      </Grid>
      <EntryInfoDialog open={dialogOpen} rows={rows} rowsPerPage={rowsPerPage} page={page} count={count}
        handleClose={() => { setDialogOpen(false) }} onPageChange={onPageChange} onRowsPerPageChange={onRowsPerPageChange} />
    </>
  );
};

/** react-redux */
const mapStateToProps = (state) => {
  return {
    winNums: state.admin.winNums,
    winnerCount: state.admin.winnerCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    open: () => dispatch(open()),
    close: () => dispatch(close()),
    update: (...args) => dispatch(update(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Content);
